@if (attribute) {
  <div [class.invisible]="isLoading">
    <app-field-label [attribute]="attribute"
    [passportId]="passportId"></app-field-label>
    <ix-input
      [formControl]="control"
      [invalidText]="createInvalidText(control)"
      [maxLength]="attribute.max || null"
      [minLength]="attribute.min || null"
      [ngClass]="{'ix-invalid': control.errors}"
      class="w-100"
      id="{{ attribute.name }}"
      />
    </div>
  }
  <ix-spinner [class.d-none]="!isLoading"></ix-spinner>
